import * as Yup from "yup";
import {
  isValidPhoneNumber,
  isValidZip,
  isValidZipEditProfile
} from "utils/validation";

const EditProfileFormValidation = translate => {
  return Yup.object().shape({
    patient_information: Yup.object().shape({
      first_name: Yup.string()
        .max(100, translate("tooManyCharacters"))
        .required(translate("enterFirstName")),
      last_name: Yup.string()
        .max(100, translate("tooManyCharacters"))
        .required(translate("enterLastName")),
      phone_number: Yup.string()
        .required(translate("enterPhoneNumber"))
        .test(
          "valid-number",
          translate("enterValidPhoneNumber"),
          isValidPhoneNumber
        ),
      mobile_number: Yup.string().test(
        "valid-mobile-number",
        translate("enterValidPhoneNumber"),
        isValidPhoneNumber
      ),
      home_address: Yup.object().shape({
        street_address: Yup.string().required(translate("enterStreetAddress")),
        state: Yup.string().required(translate("enterState")),
        zip: Yup.string()
          .required(translate("enterZip"))
          .test("valid-zip", translate("enterValidZip"), isValidZip),
        city: Yup.string().required(translate("enterCity"))
      })
    }),
    patient_insurances: Yup.array()
      .of(
        Yup.object({
          insurance_company_id: Yup.string().required(translate("required")),
          insurance_phone: Yup.string().test(
            "valid-insurance-phone-number",
            translate("enterValidPhoneNumber"),
            isValidPhoneNumber
          ),
          insurance_address: Yup.object().shape({
            zip: Yup.string().test(
              "valid-insurance-zip",
              translate("enterValidZip"),
              isValidZipEditProfile
            )
          })
        })
      )
      .required(translate("insuranceRequired")),
    // physician_information: Yup.object().shape({
    //   name: Yup.string().required("Please enter physician name"),
    //   fax: Yup.string().test(
    //     "valid-pysician-fax-number",
    //     translate("enterValidFax"),
    //     isValidPhoneNumber
    //   ),
    //   phone: Yup.string().test(
    //     "valid-physician-number",
    //     translate("enterValidPhoneNumber"),
    //     isValidPhoneNumber
    //   ),
    //   address: Yup.object().shape({
    //     zip: Yup.string().test(
    //       "valid-physician-zip",
    //       translate("enterValidZip"),
    //       isValidZipEditProfile
    //     )
    //   })
    // }),
    physicians: Yup.array().of(
      Yup.object().shape({
        name: Yup.string(),
        fax: Yup.string().test(
          "valid-pysician-fax-number",
          translate("enterValidFax"),
          isValidPhoneNumber
        ),
        phone: Yup.string().test(
          "valid-physician-phone-number",
          translate("enterValidPhoneNumber"),
          isValidPhoneNumber
        ),
        npi: Yup.string(),
        address: Yup.object().shape({
          street_address: Yup.string(),
          street_address2: Yup.string(),
          city: Yup.string(),
          state: Yup.string(),
          zip: Yup.string().test(
            "valid-physician-zip",
            translate("enterValidZip"),
            isValidZipEditProfile
          )
        })
      })
    )
  });
};
export default EditProfileFormValidation;
